import React from 'react';
import { Grid } from '@mui/material';

import {
	BooleanField,
	ModuleSearchField,
	PhoneNumberField,
	SelectField,
	SimpleTextField,
	useSettings
} from 'app/main/components';
import { type DetailsSectionInfoContentProps } from 'app/main/components/page-layouts';

export default function PhonesDetailsSectionInfo(
	props: DetailsSectionInfoContentProps & { disableIdentityAssociation?: boolean }
) {
	const { t } = useSettings();

	return (
		<>
			<Grid size={{ sm: 6, xs: 12 }}>
				{/* PHONE NUMBER */}
				<PhoneNumberField
					name="phon_title"
					label={t('DETAILS_PHONES_FIELD_TITLE')}
					value={props.model.phon_title}
					isEdit
					sendChange={props.sendChange}
					required
					validationError={t('ERROR_TEXT_REQUIRED')}
				/>
			</Grid>
			<Grid size={{ sm: 6, xs: 12 }}>
				{/* DESCRIPTION */}
				<SimpleTextField
					name="phon_description"
					label={t('DETAILS_PHONES_FIELD_DESCRIPTION')}
					value={props.model.phon_description}
					isEdit
					sendChange={props.sendChange}
				/>
			</Grid>
			{!props.disableIdentityAssociation && (
				<>
					<Grid size={{ sm: 4, xs: 12 }}>
						{/* PHONE SOURCE TABLE */}
						<SelectField
							name="phon_table"
							label={t('CONTACTS_LINKED_TABLE')}
							options={[{ value: 'users', title: t('MODULE_USERS_NAME') }]}
							value={props.model.phon_table}
							isEdit
							sendChange={props.sendChange}
						/>
					</Grid>
					<Grid size={{ sm: 8, xs: 12 }}>
						{/* PHONE SOURCE ITEM */}
						{props.model.phon_table && (
							<ModuleSearchField
								name="phon_table_uid"
								label={props.model.phon_table ? t(`MODULE_${props.model.phon_table}_NAME`) : ''}
								module={props.model.phon_table}
								uid={props.model.phon_table_uid}
								isEdit
								sendChange={props.sendChange}
								required
								validationError={t('ERROR_TEXT_REQUIRED')}
							/>
						)}
					</Grid>
				</>
			)}
			<Grid size={12}>
				{/* DEFAULT */}
				<BooleanField
					name="phon_default"
					label={t('DETAILS_PHONES_FIELD_DEFAULT')}
					value={props.model.phon_default}
					isEdit
					sendChange={props.sendChange}
				/>
			</Grid>
		</>
	);
}
